import { FC } from 'react';
import './NotificationDot.scss';

const NotificationDot: FC = () => (
  <div className=" bg-danger rounded-circle notification-dot" />
);

export default NotificationDot;
